// Return-to-link after login: a logged-out visitor opening a protected page
// (e.g. a /scene?modelId=… link someone sent them) is sent to
// /login?next=<that page>, and after logging in lands back on it instead
// of the dashboard.
//
// `next` is only ever honoured as a same-origin path to one of the app's
// own routes — never an absolute URL or protocol-relative "//host" — so the
// login page can't be used as an open redirect to another site.

const ALLOWED_PATHS = ['/', '/scene', '/captures', '/upload'];

// /login URL that returns to `path` (path + query, e.g. location.pathname +
// location.search) after login. Plain /login for the dashboard or /login itself.
export function loginUrlFor(path) {
  if (!path || path === '/' || path.startsWith('/login')) return '/login';
  return `/login?next=${encodeURIComponent(path)}`;
}

// Where to go after a successful login: the validated `next` from the
// current URL, else the dashboard.
export function postLoginTarget() {
  try {
    const next = new URLSearchParams(window.location.search).get('next');
    if (!next || !next.startsWith('/') || next.startsWith('//') || next.includes('\\')) return '/';
    const url = new URL(next, window.location.origin);
    if (url.origin !== window.location.origin) return '/';
    if (!ALLOWED_PATHS.includes(url.pathname)) return '/';
    return url.pathname + url.search + url.hash;
  } catch (e) {
    return '/';
  }
}
